import Reveal from "@/components/site/Reveal";

export default function CalIntro() {
  return (
    <section
      data-testid="cal-intro"
      className="py-20 md:py-24 bg-[#FAF7F8]"
    >
      <div className="max-w-3xl mx-auto px-6 md:px-12 text-center">
        <Reveal>
          <p className="text-lg md:text-xl text-[#1E1E2A] font-serif-display leading-[1.5]">
            Les ateliers se déroulent en petits groupes, dans un cadre structuré
            et confidentiel.
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-6 inline-block px-5 py-2.5 rounded-full bg-[#F3EEF4] border border-[#DDD7E2]">
            <p className="text-sm text-[#3A2E6E] font-medium">
              Les places étant limitées, l'inscription se fait en amont.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
